@for (event of events; track event) {
    <ul>
        <li class="event" [class.ack-background]="this.ackEnabled(event) && event.ACK">
            <app-alarm-type-span [severity]="event.severity" fxFlex="10"></app-alarm-type-span>
            <div class="info" fxFlex="75">
                <div>
                    {{ "TYPE." + event.type | translate }}
                    @if (event.alarm) {
                        <span class="alarm-name">- {{ event.alarm.name }}</span>
                    }
                </div>
                <div>
                    @if (event.deviceData) {
                        <a routerLink="/device/{{ event.deviceId }}">{{ event.deviceData.name }}</a>
                    }
                    @if (event.deviceData) {
                        <span> - </span>
                    }
                    <span class="timestamp">{{ event.startTime | timeAgo }}</span>
                </div>
            </div>
            <div class="ack" fxFlex="15">
                @if (this.ackEnabled(event)) {
                    <div>
                        @if (!event.ACK) {
                            <div>
                                <button mat-button (click)="acknowledgeEvent(event)">
                                    <mat-icon>radio_button_unchecked</mat-icon>
                                </button>
                            </div>
                        }
                        @if (event.ACK) {
                            <div>
                                <button mat-button (click)="acknowledgeEvent(event)" disabled="true">
                                    <mat-icon class="border-icon">check_circle_outline</mat-icon>
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </li>
    </ul>
}
